var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es327.js.map
